import { useState } from "react";
import { X } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/site/Primitives";
import { GALLERY, CERTIFICATES } from "@/data/site";

export const Gallery = () => {
  const [lightbox, setLightbox] = useState(null);

  return (
    <section id="galerie" className="relative py-24 lg:py-36 bg-cream">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <div className="max-w-2xl">
            <Eyebrow>Einblicke</Eyebrow>
            <h2 className="mt-6 font-serif font-light tracking-tight text-charcoal text-4xl sm:text-5xl leading-tight">
              Ein Ort zum Wohlfühlen
            </h2>
            <p className="mt-6 text-charcoal-soft leading-relaxed">
              Ruhe, Eleganz und eine warme Atmosphäre – lernen Sie meine Praxis und die Räume kennen.
            </p>
          </div>
        </Reveal>

        {/* Photo grid */}
        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
          {GALLERY.map((g, i) => (
            <Reveal
              key={i}
              delay={(i % 4) * 0.06}
              className={i === 0 ? "col-span-2 row-span-2" : ""}
            >
              <button
                data-testid={`gallery-item-${i}`}
                onClick={() => setLightbox(g.src)}
                className={`group relative w-full overflow-hidden rounded-2xl ring-1 ring-gold/20 ${
                  i === 0 ? "h-72 lg:h-full" : "h-40 lg:h-56"
                }`}
              >
                <img
                  src={g.src}
                  alt={g.label}
                  className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                />
                <span className="absolute inset-0 bg-charcoal/0 group-hover:bg-charcoal/20 transition-colors duration-500" />
                <span className="absolute bottom-3 left-3 text-xs text-cream bg-charcoal/50 backdrop-blur-sm px-3 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {g.label}
                </span>
              </button>
            </Reveal>
          ))}
        </div>

        {/* Certificates */}
        <Reveal>
          <div className="mt-24 max-w-2xl">
            <Eyebrow>Zertifikate & Nachweise</Eyebrow>
            <h3 className="mt-6 font-serif font-light tracking-tight text-charcoal text-3xl sm:text-4xl">
              Geprüfte Kompetenz, der Sie vertrauen können
            </h3>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 lg:gap-6">
          {CERTIFICATES.map((c, i) => (
            <button
              key={i}
              data-testid={`cert-${i}`}
              onClick={() => setLightbox(c.src)}
              className="group text-left"
            >
              <div className="aspect-[3/4] w-full overflow-hidden rounded-xl bg-white ring-1 ring-gold/20 shadow-[0_10px_30px_-18px_rgba(44,38,33,0.5)] p-2.5 flex items-center justify-center transition-transform duration-500 group-hover:-translate-y-1">
                <img
                  src={c.src}
                  alt={c.label}
                  loading="lazy"
                  className="max-h-full max-w-full object-contain rounded-md"
                />
              </div>
              <p className="mt-3 text-xs text-charcoal-muted leading-snug px-1">{c.label}</p>
            </button>
          ))}
        </div>
      </div>

      {lightbox && (
        <div
          data-testid="lightbox"
          className="fixed inset-0 z-[70] bg-charcoal/90 backdrop-blur-sm flex items-center justify-center p-6"
          onClick={() => setLightbox(null)}
        >
          <button
            data-testid="lightbox-close"
            className="absolute top-6 right-6 text-cream/80 hover:text-cream"
            aria-label="Schließen"
          >
            <X size={30} />
          </button>
          <img
            src={lightbox}
            alt="Vergrößerte Ansicht"
            className="max-h-[88vh] max-w-full rounded-xl object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};
